import { Alert, Box, Button, Container, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import globalContext from '../context/context'
import axios from "axios";
import { useTranslation } from "react-i18next";

function MyCart() {

    const { t } = useTranslation();
    
    const { contextData: { user, authKey, cart }, login, isLoggedIn, activateCart } = useContext(globalContext);
    const navigate = useNavigate();

    const [carts, setCarts] = useState([]);

    useEffect(() => {
        if (!authKey) {
            navigate('/login');
        } else {

            if (isLoggedIn()) {

                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);

                axios.get(`/api/shopping-carts?userId.equals=${user?.id}&createdDate.greaterThanOrEqual=${yesterday.toISOString()}`)
                    .then(res => {
                        if (res?.data) {
                            setCarts(res?.data);
                        }
                    }).catch(err => console.log(err))
            }

        }
    }, [user, authKey])


    const handleSetToActive = (cartid) => {
        activateCart(cartid)
    }


    return (
        <Box sx={{ py: 5, bgcolor: 'rgba(0,0,0, .2)' }}>
            <Container>
                <Paper sx={{ p: 3, bgcolor: '#fff', m: 3 }}>
                    <Typography sx={{ fontSize: '32px', fontWeight: 300, textAlign: 'center', pb: 2 }}>{t("MyCart.myCarts")}</Typography>
                    <Button component={Link} to="/my-booking">{t("MyCart.myBookings")}</Button>

                    <Box sx={{ width: '100%' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t("MyCart.orderNr")}</TableCell>
                                    <TableCell align="right">{t("MyCart.name")}</TableCell>
                                    <TableCell align="right">{t("MyCart.flightNr")}</TableCell>
                                    <TableCell align="right"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {carts?.filter(c => !c?.order||c?.order?.status==='PENDING_PAYMENT')?.map(c => (<TableRow key={c.id}>
                                    <TableCell component="th" scope="row">
                                        #{c.id}
                                    </TableCell>
                                    <TableCell align="right">{c?.firstName} {c?.surname}</TableCell>
                                    <TableCell align="right">{c?.directionTo?.flightNumber} {c?.directionFrom?.flightNumber}</TableCell>
                                    <TableCell align="right">
                                        {cart?.id=== c.id ? <Alert>{t("MyCart.activeCart")}</Alert> : <Button onClick={() => handleSetToActive(c.id)}>
                                            {t("MyCart.setActive")}
                                        </Button>}
                                    </TableCell>
                                </TableRow>))}
                            </TableBody>
                        </Table>
                    </Box>
                </Paper>
            </Container>

        </Box>


    );
}

export default MyCart;
